/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPSyncProduct = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ERPSyncProduct model module.
   * @module model/ERPSyncProduct
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ERPSyncProduct</code>.
   * @alias module:model/ERPSyncProduct
   * @class
   */
  var exports = function() {
    var _this = this;


















  };

  /**
   * Constructs a <code>ERPSyncProduct</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ERPSyncProduct} obj Optional instance to populate.
   * @return {module:model/ERPSyncProduct} The populated <code>ERPSyncProduct</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('ProductCode')) {
        obj['ProductCode'] = ApiClient.convertToType(data['ProductCode'], 'String');
      }
      if (data.hasOwnProperty('ProductGroupName')) {
        obj['ProductGroupName'] = ApiClient.convertToType(data['ProductGroupName'], 'String');
      }
      if (data.hasOwnProperty('ParentProductID')) {
        obj['ParentProductID'] = ApiClient.convertToType(data['ParentProductID'], 'Integer');
      }
      if (data.hasOwnProperty('UnitPrice')) {
        obj['UnitPrice'] = ApiClient.convertToType(data['UnitPrice'], 'Number');
      }
      if (data.hasOwnProperty('InventoryAmount')) {
        obj['InventoryAmount'] = ApiClient.convertToType(data['InventoryAmount'], 'Integer');
      }
      if (data.hasOwnProperty('Added')) {
        obj['Added'] = ApiClient.convertToType(data['Added'], 'Date');
      }
      if (data.hasOwnProperty('ExternalID')) {
        obj['ExternalID'] = ApiClient.convertToType(data['ExternalID'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Code')) {
        obj['Code'] = ApiClient.convertToType(data['Code'], 'String');
      }
      if (data.hasOwnProperty('ParentGroupName')) {
        obj['ParentGroupName'] = ApiClient.convertToType(data['ParentGroupName'], 'String');
      }
      if (data.hasOwnProperty('ParentGroupID')) {
        obj['ParentGroupID'] = ApiClient.convertToType(data['ParentGroupID'], 'Integer');
      }
      if (data.hasOwnProperty('IsUserOverride')) {
        obj['IsUserOverride'] = ApiClient.convertToType(data['IsUserOverride'], 'Boolean');
      }
      if (data.hasOwnProperty('CompanyLegalEntityID')) {
        obj['CompanyLegalEntityID'] = ApiClient.convertToType(data['CompanyLegalEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('IsActive')) {
        obj['IsActive'] = ApiClient.convertToType(data['IsActive'], 'Boolean');
      }
      if (data.hasOwnProperty('DetailsSynced')) {
        obj['DetailsSynced'] = ApiClient.convertToType(data['DetailsSynced'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {String} ProductCode
   * @default ''
   */
  exports.prototype['ProductCode'] = '';
  /**
   * @member {String} ProductGroupName
   * @default ''
   */
  exports.prototype['ProductGroupName'] = '';
  /**
   * @member {Integer} ParentProductID
   */
  exports.prototype['ParentProductID'] = undefined;
  /**
   * @member {Number} UnitPrice
   * @default 0.0
   */
  exports.prototype['UnitPrice'] = 0.0;
  /**
   * @member {Integer} InventoryAmount
   * @default 0
   */
  exports.prototype['InventoryAmount'] = 0;
  /**
   * @member {Date} Added
   */
  exports.prototype['Added'] = undefined;
  /**
   * @member {String} ExternalID
   * @default ''
   */
  exports.prototype['ExternalID'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Code
   * @default ''
   */
  exports.prototype['Code'] = '';
  /**
   * @member {String} ParentGroupName
   * @default ''
   */
  exports.prototype['ParentGroupName'] = '';
  /**
   * @member {Integer} ParentGroupID
   */
  exports.prototype['ParentGroupID'] = undefined;
  /**
   * @member {Boolean} IsUserOverride
   * @default false
   */
  exports.prototype['IsUserOverride'] = false;
  /**
   * @member {Integer} CompanyLegalEntityID
   */
  exports.prototype['CompanyLegalEntityID'] = undefined;
  /**
   * @member {Boolean} IsActive
   * @default false
   */
  exports.prototype['IsActive'] = false;
  /**
   * @member {Boolean} DetailsSynced
   * @default false
   */
  exports.prototype['DetailsSynced'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


